var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.5 57.6",
    style: {
      enableBackground: "new 0 0 69.5 57.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.8,24.8c18.7-8.1,31.1-13.5,37.3-16.1C59.9,1.3,63.6,0,66,0c0.5,0,1.7,0.1,2.5,0.7c0.6,0.5,0.8,1.2,0.9,1.7 C69.4,3,69.6,4.1,69.5,5c-1,10.1-5.1,34.7-7.2,46c-0.9,4.8-2.7,6.4-4.4,6.6c-3.7,0.3-6.5-2.5-10.1-4.8c-5.6-3.7-8.8-6-14.3-9.6 c-6.3-4.2-2.2-6.5,1.4-10.2c0.9-1,17.3-15.9,17.6-17.2c0-0.2,0.1-0.8-0.3-1.1c-0.4-0.3-0.9-0.2-1.3-0.1c-0.6,0.1-9.6,6.1-27,17.8 c-2.5,1.8-4.9,2.6-6.9,2.6c-2.3,0-6.7-1.3-10-2.4c-4-1.3-7.2-2-6.9-4.2C0.2,27.2,1.7,26,4.8,24.8L4.8,24.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram_logo.e0351d062e01d50db998e921f73b1c86.svg";
export { ForwardRef as ReactComponent };